export interface DevtoolsFormatter {
  __r_id?: string
  body: (object: object, config?: FormatterConfig) => FormatterNode
  hasBody: (object: object, config?: FormatterConfig) => boolean
  header: (object: object, config?: FormatterConfig) => FormatterNode
}

export interface FormatterConfig extends Record<PropertyKey, any> {
  __r_skipFormat?: boolean
}

export type FormatterNode =
  | null
  | readonly [
      'object',
      { config?: FormatterConfig; object?: object },
      ...FormatterNodeContent[]
    ]
  | readonly [
      keyof HTMLElementTagNameMap & string,
      { config?: FormatterConfig; style?: string },
      ...FormatterNodeContent[]
    ]

export type FormatterNodeContent =
  | boolean
  | FormatterNode
  | null
  | number
  | string
  | undefined

declare global {
  var devtoolsFormatters: DevtoolsFormatter[] | undefined
}

export function addDevtoolsFormatter(id: string, formatter: DevtoolsFormatter) {
  formatter.__r_id = id
  globalThis.devtoolsFormatters ??= []
  if (
    globalThis.devtoolsFormatters.every((formatter) => formatter.__r_id !== id)
  ) {
    globalThis.devtoolsFormatters.push(formatter)
  }
}
